import {
    get_aziende,
    get_azienda,
    create_azienda,
    update_azienda,
    attiva_azienda,
    disattiva_azienda,
    crea_utente_azienda,
    reset_password_utente_azienda,
    abilita_utente_azienda,
    disabilita_utente_azienda,
} from "@/api/api.tenant.js";

const aziende = {
    namespaced: true,

    state: {
        lista: [],
        corrente: null,
    },

    mutations: {
        SET_LISTA: (state, lista) => { state.lista = lista; },
        SET_CORRENTE: (state, azienda) => { state.corrente = azienda; },
    },

    actions: {
        carica({ commit }) {
            return new Promise((resolve, reject) => {
                get_aziende().then(resp => {
                    commit("SET_LISTA", resp.data);
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        caricaDettaglio({ commit }, id) {
            return new Promise((resolve, reject) => {
                get_azienda(id).then(resp => {
                    commit("SET_CORRENTE", resp.data);
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        // Creazione: azienda + utente insieme (dati contiene sia i campi azienda
        // che username/password/displayNameUtente/eMailUtente).
        crea({ dispatch }, dati) {
            return new Promise((resolve, reject) => {
                create_azienda(dati).then(resp => {
                    dispatch("carica");
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        aggiorna({ dispatch }, { id, dati }) {
            return new Promise((resolve, reject) => {
                update_azienda(id, dati).then(resp => {
                    dispatch("carica");
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        attiva({ dispatch }, id) {
            return new Promise((resolve, reject) => {
                attiva_azienda(id).then(resp => {
                    dispatch("carica");
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        disattiva({ dispatch }, id) {
            return new Promise((resolve, reject) => {
                disattiva_azienda(id).then(resp => {
                    dispatch("carica");
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        creaUtente({ dispatch }, { id, dati }) {
            return new Promise((resolve, reject) => {
                crea_utente_azienda(id, dati).then(resp => {
                    dispatch("caricaDettaglio", id);
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        resetPasswordUtente(_ctx, { id, nuovaPassword }) {
            return reset_password_utente_azienda(id, nuovaPassword);
        },

        abilitaUtente({ dispatch }, { id }) {
            return new Promise((resolve, reject) => {
                abilita_utente_azienda(id).then(resp => {
                    dispatch("caricaDettaglio", id);
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        disabilitaUtente({ dispatch }, { id }) {
            return new Promise((resolve, reject) => {
                disabilita_utente_azienda(id).then(resp => {
                    dispatch("caricaDettaglio", id);
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },
    },

    getters: {
        lista: state => state.lista,
        corrente: state => state.corrente,
    },
};

export default aziende;
